type EstadoCobro = 'pendiente' | 'cobrado'
type EstadoPago = 'pendiente' | 'pagado'

const CONFIG: Record<string, { color: string; label: string }> = {
  pendiente: { color: 'text-amber-700 dark:text-amber-500 border-amber-500/30', label: 'Pendiente' },
  cobrado:   { color: 'text-emerald-700 dark:text-emerald-500 border-emerald-500/30', label: 'Facturado' },
  pagado:    { color: 'text-emerald-700 dark:text-emerald-500 border-emerald-500/30', label: 'Pagado' },
}

interface Props {
  estado: EstadoCobro | EstadoPago
}

export function EstadoPagoBadge({ estado }: Props) {
  const { color, label } = CONFIG[estado] ?? CONFIG.pendiente
  return (
    <span className={`badge-gradient hover:opacity-90 text-xs font-medium px-2 py-0.5 rounded-full border ${color}`}>
      {label}
    </span>
  )
}
